import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=954e1098&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports